import { useBaseUploadForm } from "@usher/pe-client-front-end-lib"
import { clsx } from "clsx"
import { LoaderCircle, Upload } from "lucide-react"
import { useEffect, useRef } from "react"

export const FileUploader = ({
  type,
  onSuccess,
  verification,
}: {
  type: string
  onSuccess?: (fileName: string, fileId: string) => JSX.Element
  verification?: Record<string, boolean>
}) => {
  const uploadedRef = useRef("")
  const {
    error,
    isUploaded: uploaded,
    setFiles,
    isUploading,
    onUpload,
    files,
    getRootProps,
    getInputProps,
  } = useBaseUploadForm({
    type,
    onSuccess: onSuccess || ((fileName) => <>{fileName}</>),
    multiple: false,
  })
  const isUploaded = uploaded || (verification && verification[type])
  const selectedFile = files[0]
  const fileName = selectedFile?.name ?? ""
  const fileKey = selectedFile ? `${selectedFile.name}-${selectedFile.size}-${selectedFile.lastModified}` : ""
  useEffect(() => {
    if (!fileKey || uploadedRef.current === fileKey) return
    uploadedRef.current = fileKey
    onUpload()
  }, [fileKey, onUpload])
  const inputProps = getInputProps()
  return (
    <div className="flex items-center gap-3">
      <div {...getRootProps({ className: "block" })}>
        <input
          {...inputProps}
          onChange={(e) => {
            inputProps.onChange?.(e)
            setFiles?.([])
          }}
        />
        <div
          className={clsx("border border-gray-300 w-9 h-9 flex items-center justify-center rounded-sm cursor-pointer", {
            "!border-fuchsia-700/30 bg-fuchsia-500/10": fileName || isUploaded,
          })}
        >
          {isUploading ? <LoaderCircle className="animate-spin" /> : <Upload size={20} className="opacity-70" />}
        </div>
      </div>
      <div>
        <p className="font-bold">{fileName || "Click to Upload"}</p>
        <span
          className={clsx("text-xs", {
            "text-lime-600": isUploaded,
            "text-red-500": error !== "",
          })}
        >
          {error || (isUploaded ? "Updated successfully!" : "[Max File Size: 10MB]")}
        </span>
      </div>
    </div>
  )
}

export default FileUploader
